import { createApp } from 'vue';
import App from './App.vue';
import '@/style.css';
import router from './router';

const app = createApp(App);

// Fade-and-rise on scroll; respects reduced-motion. Progressive enhancement:
// if reduced-motion is set or IntersectionObserver is unavailable, content
// is shown immediately rather than left hidden.
app.directive('reveal', {
  mounted(el) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      el.classList.add('reveal--visible');
      return;
    }
    el.classList.add('reveal');
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.classList.add('reveal--visible');
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.12 });
    el._revealObserver = io;
    io.observe(el);
  },
  unmounted(el) {
    if (el._revealObserver) {
      el._revealObserver.disconnect();
      delete el._revealObserver;
    }
  },
});

app.use(router);
app.mount('#app');
